import { themeParams } from '@tma.js/sdk-react'

// Тёмная/светлая схема: из темы Telegram, а вне Telegram — из prefers-color-scheme.

const listeners = new Set<() => void>()

function prefersDark(): boolean {
  try {
    return window.matchMedia('(prefers-color-scheme: dark)').matches
  } catch {
    return false
  }
}

export function isDarkTheme(): boolean {
  try {
    if (themeParams.isMounted()) return themeParams.isDark()
  } catch {
    // SDK не инициализирован
  }
  return prefersDark()
}

function apply(): void {
  const dark = isDarkTheme()
  const root = document.documentElement
  root.dataset.theme = dark ? 'dark' : 'light'
  for (const meta of document.querySelectorAll<HTMLMetaElement>('meta[name="theme-color"]')) {
    meta.content = dark ? '#1E1D21' : '#F3F2F5'
  }
  for (const l of listeners) l()
}

/** Следить за сменой темы. Возвращает отписку. */
export function onThemeChange(fn: () => void): () => void {
  listeners.add(fn)
  return () => listeners.delete(fn)
}

let installed = false

export function installThemeWatcher(): void {
  if (installed) return
  installed = true
  apply()
  try {
    themeParams.isDark.sub(apply)
    themeParams.state.sub(apply)
  } catch {
    // вне Telegram
  }
  try {
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', apply)
  } catch {
    // старые WebView
  }
}
